import type { FC, ReactNode } from 'react'

import { motion } from 'motion/react'
import { getRevealProps } from '@/constants/motion'

interface RevealProps {
    children: ReactNode
    className?: string
    delay?: number
    y?: number
    x?: number
}

export const Reveal: FC<RevealProps> = ({
    children,
    className,
    delay = 0,
    y = 40,
    x = 0
}): ReactNode => {
    return (
        <motion.div className={className} {...getRevealProps(delay, y, x)}>
            {children}
        </motion.div>
    )
}
